import SessionCard from "../../../../Dashboard/Sessions/components/SessionCard";
import { Separator } from "../../../../../components/StyledComponents";
import {
  Title, SessionCardSkeleton, CardsGrid, HorizontalScrollWrapper, HorizontalScroll
} from "./styles";
import { SessionInDto } from "../../../../../types";
import { convertFloatHourToMinutes, sessionExpiredWithMargin } from "../../../../../helpers/dates-hanlder";
import { connect } from "react-redux";
import { useMemo } from "react";
import { motion } from "framer-motion";


interface ComponentProps {
  sessions: SessionInDto[];
  sessionsStates: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}


const Component = ({ sessions, sessionsStates }: ComponentProps) => {

  const filteredSessions = useMemo(() => {
    if (!sessions)
      return []

    const expiredSessions = sessions?.filter((session) => {
      let durationInMinutes = session?.duration_type === "hour" ? convertFloatHourToMinutes(session?.duration) : session?.duration
      return sessionExpiredWithMargin(session.session_datetime, durationInMinutes) && (!!session?.will_be_recorded || !!session?.recorded_session_url)
    })

    expiredSessions.sort((a, b) => new Date(a?.session_datetime).getTime() - new Date(b?.session_datetime).getTime())
    expiredSessions.reverse()

    return expiredSessions.slice(0, 3)

  }, [sessions])

  return (
    <>
      <Title>Últimos encuentros grabados</Title>
      {(!sessions && !sessionsStates.loading) ||
        ((filteredSessions?.length <= 0 ||
          sessionsStates.error) &&
          !sessionsStates.loading) ? (
        <motion.div>
          <div style={{ height: 16 }} />
          Aún no se han subido encuentros grabados.
          <div style={{ height: 16 }} />
        </motion.div>
      ) : (
        <>
          <div style={{ height: 8 }} />

          <HorizontalScrollWrapper>
            <HorizontalScroll >
              {sessionsStates.loading && (
                <>
                  <SessionCardSkeleton />
                  <SessionCardSkeleton />
                  <SessionCardSkeleton />
                </>
              )}

              {!sessionsStates.loading &&
                filteredSessions?.map((session) => (
                  <SessionCard
                    bigCard
                    groupInformation={session.group}
                    key={`session-${session.id}`}
                    session={session}
                    link={`/group/${session?.group}/s/${session.id}`}

                  />

                ))}
            </HorizontalScroll >
          </HorizontalScrollWrapper>
        </>
      )}
    </>
  );
};

const state = ({ sessionStore }) => {
  const { data: sessions, states: sessionsStates } = sessionStore.all;

  return {
    sessions,
    sessionsStates,
  };
};

export default connect(state)(Component);
